import { PageHeader } from '@/components/ui';

import { CartaoVinculos } from './CartaoVinculos';

/**
 * A página do Vinculos — 06/09/2026, quando `Integrações` deixou de ser uma
 * pilha e cada integração ganhou a sua.
 *
 * ⚠️ O conteúdo é o MESMO cartão de antes, sem uma linha de lógica tocada.
 * **Reorganização de tela não é reorganização de dado** — o que muda é onde a
 * pessoa encontra, não o que o sistema faz.
 */
export function PaginaVinculos() {
  return (
    <section className="min-w-0 space-y-6" data-testid="pagina-vinculos">
      <PageHeader className="mb-0" crumb="Configurações · Integrações" title="Vínculos de cliente" subtitle="Cadastros do Omie e do Auvo esperando par aqui dentro. Casar é ato humano: o sistema nunca casa por nome." />
      <CartaoVinculos />
    </section>
  );
}
